import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';

@Component({
  components: {

  },
})
export default class SetupSLIDBanner extends Base {

  dismiss() {
    this.setupSLIDBannerDismissed = true;
  }

  get setupSLIDBannerDismissed(): boolean {
    return this.userModule.setupSLIDBannerDismissed;
  }

  set setupSLIDBannerDismissed(dismissed: boolean) {
    this.userModule.setSetupSLIDBannerDismissed(dismissed);
  }
}
